exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.student-card[data-v-0502e6ca]{background:var(--v-primary-base);color:#fff;border-radius:10px;-webkit-box-shadow:0 0 12px rgba(32,41,89,0.8);box-shadow:0 0 12px rgba(32,41,89,0.8)\n}\n", "", {"version":3,"sources":["/builds/datahouse2/doe/osss/medicaid-apps/pt-service-logs-ui/src/components/service-log/form/student-card.vue"],"names":[],"mappings":";AA4EA,+BACE,iCACA,WACA,mBACA,+CAAA,sCAA0C;CAC3C","file":"student-card.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.student-card {\n  background: var(--v-primary-base);\n  color: #fff;\n  border-radius: 10px;\n  box-shadow: 0 0 12px rgba(32, 41, 89, 0.8);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0502e6ca","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/service-log/form/student-card.vue
// module id = PLS4
// module chunks = 1